import {
  IContact,
  ContactFilters,
  GetContactsResponse,
  CreateContactRequest,
  UpdateContactRequest,
  BulkCreateContactsRequest,
  BulkCreateContactsResponse,
  ContactSegmentsFilters,
  GetContactSegmentsResponse,
  GetContactActivityResponse,
} from '../../types/contacts/contacts.types';
import { EmailSentHistoryFilters } from '../../types/emailSentHistory/emailSentHistory.types';
import { GetContactEmailsResponse } from '../../types/contacts/contacts.types';
import {
  GET_CONTACTS_REQUEST,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAILURE,
  GET_CONTACT_REQUEST,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAILURE,
  CREATE_CONTACT_REQUEST,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILURE,
  UPDATE_CONTACT_REQUEST,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAILURE,
  DELETE_CONTACT_REQUEST,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE,
  GetContactsRequestAction,
  GetContactsSuccessAction,
  GetContactsFailureAction,
  GetContactRequestAction,
  GetContactSuccessAction,
  GetContactFailureAction,
  DeleteContactRequestAction,
  DeleteContactSuccessAction,
  DeleteContactFailureAction,
  CLEAR_CONTACT_STATE,
  ClearContactStateAction,
  CreateContactFailureAction,
  CreateContactSuccessAction,
  CreateContactRequestAction,
  UpdateContactSuccessAction,
  UpdateContactRequestAction,
  UpdateContactFailureAction,
  BULK_CREATE_CONTACTS_REQUEST,
  BULK_CREATE_CONTACTS_SUCCESS,
  BULK_CREATE_CONTACTS_FAILURE,
  BulkCreateContactsRequestAction,
  BulkCreateContactsSuccessAction,
  BulkCreateContactsFailureAction,
  BULK_DELETE_CONTACTS_REQUEST,
  BULK_DELETE_CONTACTS_SUCCESS,
  BULK_DELETE_CONTACTS_FAILURE,
  BulkDeleteContactsRequestAction,
  BulkDeleteContactsSuccessAction,
  BulkDeleteContactsFailureAction,
  CLEAR_BULK_DELETE_CONTACTS_STATE,
  ClearBulkDeleteContactsStateAction,
  EXPORT_CONTACTS_CSV_REQUEST,
  EXPORT_CONTACTS_CSV_SUCCESS,
  EXPORT_CONTACTS_CSV_FAILURE,
  ExportContactsCSVRequestAction,
  ExportContactsCSVSuccessAction,
  ExportContactsCSVFailureAction,
  CLEAR_EXPORT_STATE,
  ClearExportStateAction,
  DELETE_ALL_CONTACTS_REQUEST,
  DELETE_ALL_CONTACTS_SUCCESS,
  DELETE_ALL_CONTACTS_FAILURE,
  DeleteAllContactsRequestAction,
  DeleteAllContactsSuccessAction,
  DeleteAllContactsFailureAction,
  CLEAR_DELETE_ALL_CONTACTS_STATE,
  ClearDeleteAllContactsStateAction,
  GET_CONTACT_SEGMENTS_REQUEST,
  GET_CONTACT_SEGMENTS_SUCCESS,
  GET_CONTACT_SEGMENTS_FAILURE,
  GetContactSegmentsRequestAction,
  GetContactSegmentsSuccessAction,
  GetContactSegmentsFailureAction,
  GetContactActivityRequestAction,
  GetContactActivitySuccessAction,
  GetContactActivityFailureAction,
  GET_CONTACT_ACTIVITY_REQUEST,
  GET_CONTACT_ACTIVITY_SUCCESS,
  GET_CONTACT_ACTIVITY_FAILURE,
  GetContactEmailsRequestAction,
  GetContactEmailsSuccessAction,
  GetContactEmailsFailureAction,
  GET_CONTACT_EMAILS_REQUEST,
  GET_CONTACT_EMAILS_SUCCESS,
  GET_CONTACT_EMAILS_FAILURE,
} from './contacts.types';

// Get Contacts Actions
export const getContactsRequest = (
  filters: ContactFilters = {}
): GetContactsRequestAction => ({
  type: GET_CONTACTS_REQUEST,
  payload: filters,
});

export const getContactsSuccess = (
  response: GetContactsResponse
): GetContactsSuccessAction => ({
  type: GET_CONTACTS_SUCCESS,
  payload: response,
});

export const getContactsFailure = (
  error: string
): GetContactsFailureAction => ({
  type: GET_CONTACTS_FAILURE,
  payload: error,
});

// Get Contact Actions
export const getContactRequest = (id: string): GetContactRequestAction => ({
  type: GET_CONTACT_REQUEST,
  payload: id,
});

export const getContactSuccess = (
  contact: IContact
): GetContactSuccessAction => ({
  type: GET_CONTACT_SUCCESS,
  payload: contact,
});

export const getContactFailure = (error: string): GetContactFailureAction => ({
  type: GET_CONTACT_FAILURE,
  payload: error,
});

// Upsert Contact Actions
export const createContactRequest = (
  contactData: CreateContactRequest
): CreateContactRequestAction => ({
  type: CREATE_CONTACT_REQUEST,
  payload: contactData,
});

export const createContactSuccess = (
  contact: IContact
): CreateContactSuccessAction => ({
  type: CREATE_CONTACT_SUCCESS,
  payload: contact,
});

export const createContactFailure = (
  error: string
): CreateContactFailureAction => ({
  type: CREATE_CONTACT_FAILURE,
  payload: error,
});

// Update Contact Actions
export const updateContactRequest = (
  contactData: UpdateContactRequest
): UpdateContactRequestAction => ({
  type: UPDATE_CONTACT_REQUEST,
  payload: contactData,
});

export const updateContactSuccess = (
  contact: IContact
): UpdateContactSuccessAction => ({
  type: UPDATE_CONTACT_SUCCESS,
  payload: contact,
});

export const updateContactFailure = (
  error: string
): UpdateContactFailureAction => ({
  type: UPDATE_CONTACT_FAILURE,
  payload: error,
});

// Delete Contact Actions
export const deleteContactRequest = (
  id: string
): DeleteContactRequestAction => ({
  type: DELETE_CONTACT_REQUEST,
  payload: id,
});

export const deleteContactSuccess = (
  id: string
): DeleteContactSuccessAction => ({
  type: DELETE_CONTACT_SUCCESS,
  payload: id,
});

export const deleteContactFailure = (
  error: string
): DeleteContactFailureAction => ({
  type: DELETE_CONTACT_FAILURE,
  payload: error,
});

export const clearContactState = (): ClearContactStateAction => ({
  type: CLEAR_CONTACT_STATE,
});

// Bulk Create Contacts Actions
export const bulkCreateContactsRequest = (
  data: BulkCreateContactsRequest
): BulkCreateContactsRequestAction => ({
  type: BULK_CREATE_CONTACTS_REQUEST,
  payload: data,
});

export const bulkCreateContactsSuccess = (
  response: BulkCreateContactsResponse
): BulkCreateContactsSuccessAction => ({
  type: BULK_CREATE_CONTACTS_SUCCESS,
  payload: response,
});

export const bulkCreateContactsFailure = (
  error: string
): BulkCreateContactsFailureAction => ({
  type: BULK_CREATE_CONTACTS_FAILURE,
  payload: error,
});

// Bulk Delete Contacts Actions
export const bulkDeleteContactsRequest = (
  contactIds: string[]
): BulkDeleteContactsRequestAction => ({
  type: BULK_DELETE_CONTACTS_REQUEST,
  payload: contactIds,
});

export const bulkDeleteContactsSuccess = (
  contactIds: string[]
): BulkDeleteContactsSuccessAction => ({
  type: BULK_DELETE_CONTACTS_SUCCESS,
  payload: contactIds,
});

export const bulkDeleteContactsFailure = (
  error: string
): BulkDeleteContactsFailureAction => ({
  type: BULK_DELETE_CONTACTS_FAILURE,
  payload: error,
});

export const clearBulkDeleteContactsState =
  (): ClearBulkDeleteContactsStateAction => ({
    type: CLEAR_BULK_DELETE_CONTACTS_STATE,
  });

// Export Contacts CSV Actions
export const exportContactsCSVRequest = (
  search?: string
): ExportContactsCSVRequestAction => ({
  type: EXPORT_CONTACTS_CSV_REQUEST,
  payload: search,
});

export const exportContactsCSVSuccess = (
  blob: Blob
): ExportContactsCSVSuccessAction => ({
  type: EXPORT_CONTACTS_CSV_SUCCESS,
  payload: blob,
});

export const exportContactsCSVFailure = (
  error: string
): ExportContactsCSVFailureAction => ({
  type: EXPORT_CONTACTS_CSV_FAILURE,
  payload: error,
});

export const clearExportState = (): ClearExportStateAction => ({
  type: CLEAR_EXPORT_STATE,
});

// Delete All Contacts Actions
export const deleteAllContactsRequest = (): DeleteAllContactsRequestAction => ({
  type: DELETE_ALL_CONTACTS_REQUEST,
});

export const deleteAllContactsSuccess = (): DeleteAllContactsSuccessAction => ({
  type: DELETE_ALL_CONTACTS_SUCCESS,
});

export const deleteAllContactsFailure = (
  error: string
): DeleteAllContactsFailureAction => ({
  type: DELETE_ALL_CONTACTS_FAILURE,
  payload: error,
});

export const clearDeleteAllContactsState =
  (): ClearDeleteAllContactsStateAction => ({
    type: CLEAR_DELETE_ALL_CONTACTS_STATE,
  });

// Get Contact Segments Actions
export const getContactSegmentsRequest = (
  contactId: string,
  filters: ContactSegmentsFilters = {}
): GetContactSegmentsRequestAction => ({
  type: GET_CONTACT_SEGMENTS_REQUEST,
  payload: { contactId, filters },
});

export const getContactSegmentsSuccess = (
  response: GetContactSegmentsResponse
): GetContactSegmentsSuccessAction => ({
  type: GET_CONTACT_SEGMENTS_SUCCESS,
  payload: response,
});

export const getContactSegmentsFailure = (
  error: string
): GetContactSegmentsFailureAction => ({
  type: GET_CONTACT_SEGMENTS_FAILURE,
  payload: error,
});

// Get Contact Activity Actions
export const getContactActivityRequest = (
  contactId: string
): GetContactActivityRequestAction => ({
  type: GET_CONTACT_ACTIVITY_REQUEST,
  payload: contactId,
});

export const getContactActivitySuccess = (
  response: GetContactActivityResponse
): GetContactActivitySuccessAction => ({
  type: GET_CONTACT_ACTIVITY_SUCCESS,
  payload: response,
});

export const getContactActivityFailure = (
  error: string
): GetContactActivityFailureAction => ({
  type: GET_CONTACT_ACTIVITY_FAILURE,
  payload: error,
});

// Get Contact Emails Actions
export const getContactEmailsRequest = (
  contactId: string,
  filters: EmailSentHistoryFilters = {}
): GetContactEmailsRequestAction => ({
  type: GET_CONTACT_EMAILS_REQUEST,
  payload: { contactId, filters },
});

export const getContactEmailsSuccess = (
  response: GetContactEmailsResponse
): GetContactEmailsSuccessAction => ({
  type: GET_CONTACT_EMAILS_SUCCESS,
  payload: response,
});

export const getContactEmailsFailure = (
  error: string
): GetContactEmailsFailureAction => ({
  type: GET_CONTACT_EMAILS_FAILURE,
  payload: error,
});
